import { NgModule } from '@angular/core';
import { ThemeComponent } from './theme.component';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from "../auth/_guards/auth.guard";

const routes: Routes = [
    {
        "path": "non-club-athlete",
        "loadChildren": ".\/pages\/aside-left-display-disabled-loader-enabled-enabled-type-spinner-message\/non-club-athlete\/index.module#IndexModule"
    },
    {
        "path": "",
        "component": ThemeComponent,
        "canActivate": [AuthGuard],
        "children": [
            {
                "path": "index",
                "loadChildren": ".\/pages\/aside-left-display-disabled-loader-enabled-enabled-type-spinner-message\/index\/index.module#IndexModule"
            },
            {
                "path": "inner",
                "loadChildren": ".\/pages\/default\/inner\/inner.module#InnerModule"
            },
            {
                "path": "inner2",
                "loadChildren": ".\/pages\/default\/inner2\/inner2.module#Inner2Module"
            },
            {
                "path": "profile",
                "loadChildren": ".\/pages\/default\/profile\/profile.module#ProfileModule"
            },
            {
                "path": "roster",
                "loadChildren": ".\/pages\/default\/roster\/roster.module#RosterModule"
            },
            {
                "path": "athlete/:athleteId",
                "loadChildren": ".\/pages\/default\/athletedetails\/athletedetails.module#AthleteDetailsModule"
            },
            {
                "path": "teams",
                "loadChildren": ".\/pages\/default\/teams\/teams.module#TeamModule"
            },
            {
                "path": "teams/:teamId",
                "loadChildren": ".\/pages\/default\/teamdetails\/teamdetails.module#TeamDetailsModule"
            },
            {
                "path": "workflows",
                "loadChildren": ".\/pages\/default\/workflows\/workflows.module#WorkflowModule"
            },
            {
                "path": "reports",
                "loadChildren": ".\/pages\/default\/reports\/reports.module#ReportModule"
            },
            {
                "path": "association/clubs",
                "loadChildren": ".\/pages\/default\/association\/clubs\/clubs.module#ClubsModule"
            },
            {
                "path": "association/clubs/:clubId",
                "loadChildren": ".\/pages\/default\/association\/clubdetails\/clubdetails.module#ClubDetailsModule"
            },
            {
                "path": "association/staff",
                "loadChildren": ".\/pages\/default\/association\/staff\/staff.module#StaffModule"
            },
            {
                "path": "association/staff/:staffId",
                "loadChildren": ".\/pages\/default\/association\/staffdetails\/staffdetails.module#StaffDetailsModule"
            },
            {
                "path": "association/dashboard",
                "loadChildren": ".\/pages\/default\/association\/dashboard\/dashboard.module#DashboardModule"
            },
            {
                "path": "club/dashboard",
                "loadChildren": ".\/pages\/default\/club\/dashboard\/dashboard.module#ClubDashboardModule"
            },
            {
                "path": "parent/dashboard",
                "loadChildren": ".\/pages\/default\/parent\/dashboard\/dashboard.module#ParentDashboardModule"
            },
            {
                "path": "parent/dashboard/:athleteId",
                "loadChildren": ".\/pages\/default\/parent\/dashboard\/dashboard.module#ParentDashboardModule"
            },
            {
                "path": "parent/athletes",
                "loadChildren": ".\/pages\/default\/parent\/athletes\/athletes.module#ParentAthletesModule"
            },
            {
                "path": "sgadmin/dashboard",
                "loadChildren": ".\/pages\/default\/sgadmin\/dashboard\/dashboard.module#DashboardModule"
            },
            {
                "path": "sgadmin/clubs",
                "loadChildren": ".\/pages\/default\/sgadmin\/clubs\/clubs.module#ClubsModule"
            },
            {
                "path": "404",
                "loadChildren": ".\/pages\/default\/not-found\/not-found.module#NotFoundModule"
            },
            {
                "path": "",
                "redirectTo": "index",
                "pathMatch": "full"
            }
        ]
    },

    {
        "path": "**",
        "redirectTo": "404",
        "pathMatch": "full"
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ThemeRoutingModule { }


// WEBPACK FOOTER //
// ./src/app/theme/theme-routing.module.ts